import React from "react";
import classnames from "classnames";
import { COLORS } from "utils/styles";

const CITATIONS = [
  {
    copy: "[1], [2] Baymard cart abandonment rate study",
    href: "https://baymard.com/lists/cart-abandonment-rate"
  },
  {
    copy: "[3] Shopify Omnichannel Commerce Guide",
    href:
      "https://enterprise.plus.shopify.com/rs/932-KRM-548/images/Omnichannel_Commerce_Guide.pdf"
  },
  {
    copy: "[4] Statista global mobile messenger apps",
    href:
      "https://www.statista.com/statistics/258749/most-popular-global-mobile-messenger-apps/"
  },
  {
    copy: "[5] Tap into the marketing power of SMS",
    href:
      "https://www.gartner.com/en/marketing/insights/articles/tap-into-the-marketing-power-of-sms"
  },
  {
    copy: "[6] How oem pay is disrupting the contactless payments' landscape",
    href:
      "https://www.juniperresearch.com/document-library/white-papers/how-oem-pay-is-disrupting-the-contactless-payments"
  }
];

const Citations = () => (
  <div className="f7 w-100 lh-copy" style={{ color: COLORS.disclaimer }}>
    {CITATIONS.map((citation, citationIx) => (
      <span key={citationIx}>
        <a
          href={citation.href}
          target="_blank"
          className={classnames("color-text--secondary fw5 w-100", {
            pl1: citationIx
          })}
          rel="noreferrer noopener"
        >
          {citation.copy}
        </a>
      </span>
    ))}
  </div>
);

export default Citations;
